import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    statusModalGrid: { marginBottom: 16 },

    options: {
      margin: 8,
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${palette.gray}`,
      cursor: 'pointer',
      borderRadius: 30,
      padding: '4px 8px',
      '& .MuiCheckbox-root': { padding: '0px 2px 0px 0px !important' },
    },
    optionsSelected: {
      border: `1px solid ${palette.green}`,
      cursor: 'pointer',
      backgroundColor: palette.lightGreen,
      padding: '4px 6px',
    },
    ghostCheckIcon: { fontSize: 0, color: palette.white },
    checkIcon: { fontSize: 20, color: palette.green },
    activeAllText: {
      fontSize: 15,
      fontWeight: 500,
      marginRight: 6,
    },
    optionTextSelected: {
      fontSize: 15,
      fontWeight: 500,
      color: palette.green,
      marginRight: 6,
    },
  });
